import { render, staticRenderFns } from "./company-navigation-current-package.vue?vue&type=template&id=0b9c1690&scoped=true"
import script from "./company-navigation-current-package.vue?vue&type=script&lang=js"
export * from "./company-navigation-current-package.vue?vue&type=script&lang=js"
import style0 from "./company-navigation-current-package.vue?vue&type=style&index=0&id=0b9c1690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c1690",
  null
  
)

export default component.exports